import { render } from "./IndexBankDetailsPage.vue?vue&type=template&id=cd074ffa"
import script from "./IndexBankDetailsPage.vue?vue&type=script&lang=js"
export * from "./IndexBankDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__